import React from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Container, Modal, ModalBody, Row, Table } from 'reactstrap';
import modalclose from '../../../images/close1.png';
import DateService from '../../../services/DateService';
import './index.css';

const MeetingModal = ({ isOpen, toggle, meetingRowData, mActivityData }) => {
    let { dealer_code, business_name, primary_contact_name, primary_contact_mobile, meeting_date, meeting_summary, city, territory, created_by, updated_at, created_at } = meetingRowData;

    const location = useLocation();
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered className="meetingModal" id="meetingModal">
            <ModalBody className='p-0'>
                <div className='modalHeading mb-0'>
                    <div className='title'>Meeting Activity</div>
                    <div className="closeButton d-flex justify-content-end"><img src={modalclose} alt="close" onClick={toggle} /></div>
                </div>
                <div className='bodyArea'>
                    <Container fluid>
                        <Row>
                            <Col xs={12}>
                                <div className='blockArea'>
                                    <Row>
                                        <Col xs={12}>
                                            <div className='blockTitle'>Meeting Information</div>
                                        </Col>
                                        <Col md={6}>
                                            <div className='topBlock'>
                                                <div className='textWrapper'><span className='innerTitle'>Dealer Code : </span>{dealer_code || 'N/A'}<span></span></div>
                                                <div className='textWrapper'><span className='innerTitle'>Dealership Name : </span>{business_name || 'N/A'}<span></span></div>
                                                <div className='textWrapper'><span className='innerTitle'>owner Name : </span>{primary_contact_name || 'N/A'}<span></span></div>
                                                <div className='textWrapper'><span className='innerTitle'>Mobile No : </span>{primary_contact_mobile || 'N/A'}<span></span></div>
                                                <div className='textWrapper'><span className='innerTitle'>Meeting Date : </span>{DateService.utcToLocalDate(meeting_date) || 'N/A'}<span></span></div>
                                                {location && location.pathname.includes('meeting-history') ?
                                                    <div className='textWrapper'><span className='innerTitle'>Meeting Summary : </span>{meeting_summary || 'N/A'}<span></span></div>
                                                    : ''}
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className='topBlock'>
                                                <div className='textWrapper'><span className='innerTitle'>City : </span>{city || 'N/A'}<span></span></div>
                                                <div className='textWrapper'><span className='innerTitle'>Territory : </span>{territory || 'N/A'}<span></span></div>
                                                <div className='textWrapper'><span className='innerTitle'>SH / TM Name : </span>{created_by || 'N/A'}<span></span></div>
                                                <div className='textWrapper'><span className='innerTitle'>Updated At : </span>{DateService.utcToLocalDate(updated_at)  || 'N/A'}<span></span></div>
                                                <div className='textWrapper'><span className='innerTitle'>Created At : </span>{DateService.utcToLocalDate(created_at) || 'N/A'}<span></span></div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                {mActivityData && mActivityData.length > 0 && mActivityData[0].history && mActivityData[0].history.length > 0 ?
                                    <div className='blockArea bottomBlock'>
                                        <Row>
                                            <Col xs={12}>
                                                <div className='blockTitle'>Activity</div>
                                            </Col>
                                            <Col xs={12}>
                                                <div className='tableWrapper'>
                                                    <div className='activityTable'>
                                                        <Table bordered className='table table-responsive text-center'>
                                                            <tbody>
                                                                <tr className='headingRow'>
                                                                    <th>Dealership Name</th>
                                                                    <th>SH / TM Name</th>
                                                                    <th>Reschedule Date</th>
                                                                    <th>Created At</th>
                                                                    <th className='text-left'>Remarks</th>
                                                                </tr>
                                                                {mActivityData[0].history.map((elem, index) => {
                                                                    let { created_by, reschedule_date, created_at, remark } = elem;
                                                                    return (
                                                                        <>
                                                                            <tr key={index}>
                                                                                <td>{business_name || 'N/A'}</td>
                                                                                <td>{created_by || 'N/A'}</td>
                                                                                <td>
                                                                                    {reschedule_date ?
                                                                                        (
                                                                                            <>
                                                                                                <span>{DateService.utcToLocalDateOnly(reschedule_date)}</span>
                                                                                                <br />
                                                                                                <span>{DateService.utcToLocalTimeOnly(reschedule_date)}</span>
                                                                                            </>
                                                                                        )
                                                                                        : 'N/A'}
                                                                                </td>
                                                                                <td>
                                                                                    {created_at ?
                                                                                        (
                                                                                            <>
                                                                                                <>
                                                                                                <span>{DateService.utcToLocalDateOnly(created_at)}</span>
                                                                                                <br />
                                                                                                <span>{DateService.utcToLocalTimeOnly(created_at)}</span>
                                                                                            </>
                                                                                            </>
                                                                                        )
                                                                                        : 'N/A'}
                                                                                </td>
                                                                                <td className='text-left'>{remark || 'N/A'}</td>
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                })}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    : ''}
                            </Col>
                        </Row>
                    </Container>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default MeetingModal
